import {Footer} from "antd/es/layout/layout";
import React, {useContext} from "react";
import {AuthContext} from "../../config/AuthContext";
import { Tag } from "antd";

const AppFooter = () => {
    const {userId} = useContext(AuthContext);

    return (
        <>
        {userId && (
            <div
                style={{
                    position: "fixed",
                    bottom: "10px",
                    right: "10px",
                    zIndex: 1000
                }}
            >
                <Tag color="blue">Usuari: {userId}</Tag>
            </div>
        )}

            <Footer style={{textAlign: 'center'}}>
                Created by Héctor Florido.
            </Footer>
        </>
    );
}

export default AppFooter;
